import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function WorkshopsEvents() {
  const modules = [{
    index: "G01",
    duration: "3 DAYS",
    name: "SEED SAVING BASICS",
    description: "Learn the art of selecting, drying, and storing heirloom seeds to ensure your garden thrives year after year.",
    skills: ["Seed selection", "Drying techniques", "Storage protocols"],
    price: "FREE",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/seed_saving.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/seed_saving.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/seed_saving.png-wvc-sizes",
    alt: "Heirloom seeds drying on a wooden tray"
  }, {
    index: "G02",
    duration: "4 DAYS",
    name: "ORGANIC SOIL HEALTH",
    description: "Master the science of composting, vermiculture, and natural soil amendments for nutrient-dense harvests.",
    skills: ["Compost management", "Soil testing", "Natural fertilization"],
    price: "$50",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/soil_health.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/soil_health.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/soil_health.png-wvc-sizes",
    alt: "Hands working rich dark compost soil"
  }, {
    index: "G03",
    duration: "3 DAYS",
    name: "GREENHOUSE MANAGEMENT",
    description: "Extend your growing season with climate control, vertical trellising, and efficient irrigation setups.",
    skills: ["Climate regulation", "Vertical gardening", "Drip irrigation"],
    price: "$75",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/greenhouse_setup.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/greenhouse_setup.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/greenhouse_setup.png-wvc-sizes",
    alt: "Lush greenhouse interior with hanging plants"
  }, {
    index: "G04",
    duration: "2 DAYS",
    name: "PEST & DISEASE CONTROL",
    description: "Identify common garden threats and implement organic, non-toxic solutions to protect your crops.",
    skills: ["Integrated pest management", "Companion planting", "Natural remedies"],
    price: "FREE",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/pest_control.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/pest_control.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/pest_control.png-wvc-sizes",
    alt: "Ladybug on a healthy green leaf"
  }, {
    index: "G05",
    duration: "5 DAYS",
    name: "SEASONAL HARVESTING",
    description: "Learn the optimal timing for picking produce and preserving your bounty through canning and drying.",
    skills: ["Harvest timing", "Canning basics", "Dehydration methods"],
    price: "$100",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/seasonal_harvest.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/seasonal_harvest.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/seasonal_harvest.png-wvc-sizes",
    alt: "Basket full of fresh seasonal vegetables"
  }, {
    index: "G06",
    duration: "4 DAYS",
    name: "COMMUNITY PLOT DESIGN",
    description: "Collaborative planning for shared spaces, including crop rotation schedules and community resource sharing.",
    skills: ["Crop rotation", "Space planning", "Community coordination"],
    price: "$40",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/community_plot.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/community_plot.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701353/img/community_plot.png-wvc-sizes",
    alt: "Community members working in a shared garden plot"
  }];
  return <section data-section-id="2161" id="workshops-events" className="bg-background text-foreground py-20 md:py-28 px-4 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 mb-16 md:mb-20">
          <div>
            <div className="font-mono text-xs tracking-widest text-foreground mb-6">
              [ WORKSHOPS / 02 ]
            </div>
            <h2 className="font-default font-bold text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.95] tracking-tight">
              GARDENING /{" "}
              <span className="text-transparent" style={{
              WebkitTextStroke: "1px var(--foreground)"
            }}>
                WORKSHOPS
              </span>
            </h2>
          </div>
          <div className="flex items-end">
            <p className="font-default italic text-xl md:text-2xl text-foreground/80 leading-relaxed">
              Six core workshops. Each can be taken standalone or as part of our seasonal gardening curriculum.
            </p>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border">
          {modules.map((module, i) => <article data-index={i} key={module.index} className="group relative bg-card backdrop-blur-xl border border-border shadow-lg flex flex-col h-[480px] transition-all duration-300 hover:-translate-y-1 hover:border-primary overflow-hidden rounded-lg">
              {}
              <div className="relative h-[40%] overflow-hidden bg-muted">
                <img src={module.image} data-wvc-srcset={module.srcset} data-wvc-sizes={module.sizes} alt={module.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" />
                {}
                <div className="absolute bottom-0 left-0 right-0 bg-foreground/90 backdrop-blur-sm flex items-center justify-between px-4 py-2.5">
                  <span className="font-mono text-[11px] tracking-widest text-background/80">
                    {module.index} / G0{i + 1 > 6 ? 6 : ""}
                    {module.index}
                  </span>
                  <span className="font-mono text-[10px] font-semibold tracking-widest bg-primary text-primary-foreground px-2 py-1">
                    {module.duration}
                  </span>
                </div>
              </div>

              {}
              <div className="flex-1 flex flex-col p-6 bg-background">
                <h3 className="font-default font-bold text-xl md:text-2xl uppercase tracking-tight leading-tight mb-4">
                  {module.name}
                </h3>
                <div className="h-px bg-border mb-4" />
                <p className="font-default italic text-base text-foreground/70 leading-snug mb-5 line-clamp-3">
                  {module.description}
                </p>

                <ul className="space-y-2 mb-auto">
                  {module.skills.map((skill, si) => <li data-index={si} key={si} className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-widest text-foreground/80">
                      <span className="w-2 h-2 bg-primary shrink-0" />
                      {skill}
                    </li>)}
                </ul>

                {}
                <div className="flex items-center justify-between mt-6 pt-4 border-t border-border">
                  <Link to="/JoinUsPage" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-primary hover:gap-3 transition-all">
                    <ArrowRight className="size-4" />
                    WORKSHOP DETAILS
                  </Link>
                  <span className="font-mono text-sm font-semibold text-foreground">
                    {module.price}
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        {}
        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pt-10 border-t border-border">
          <p className="font-default italic text-lg text-foreground/80 max-w-xl">
            Join our full seasonal program to master organic gardening and save 20% on all workshop fees.
          </p>
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-mono text-xs uppercase tracking-widest h-12 px-8">
            <Link to="/JoinUsPage">
              View Seasonal Program
              <ArrowRight className="size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}